import { Controller } from "@hotwired/stimulus";
import { dispatchFilterUpdatedEvent } from "../../datatables/datatable_filters";
import { toggleClass } from "../../utils/misc";
import { isEnterKey } from "../../utils/inputs_utils";
import { numberToCurrency } from "../../utils/number_utils";

const FILTER_VALUES = {
  GREATER_THAN: "gt",
  LESS_THAN: "lt",
  EQUAL_TO: "eq",
  BETWEEN: "bw",
};

export default class extends Controller {
  static targets = ["form", "rangeChoiceInput", "rangeStart", "rangeEnd", "errorMessage"];
  static outlets = ["datatables--selected-filter"];

  connect() {
    const selectedRangeInput = this._selectedRangeInput();
    if (selectedRangeInput) {
      toggleClass(this.rangeEndTarget, "hidden", this._shouldShowRangeEndInput(selectedRangeInput));
    }
    if (this.hasDatatablesSelectedFilterOutlet) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    }
  }

  toggleRangeInputs(event) {
    toggleClass(this.rangeEndTarget, "hidden", this._shouldShowRangeEndInput(event.target));
    this.rangeStartTarget.focus();
  }

  filterInputChanged(event) {
    if (isEnterKey(event.keyCode)) {
      this.filterChanged();
    }
  }

  filterChanged() {
    const isFilterValid = this.formTarget.checkValidity();
    toggleClass(this.errorMessageTarget, "hidden", !isFilterValid);

    if (isFilterValid) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
      this._filterUpdated();
    }
  }

  _filterUpdated() {
    const { filterName } = this.element.dataset;
    dispatchFilterUpdatedEvent({ name: filterName });
  }

  _translatedValue() {
    const selectedRangeInput = this._selectedRangeInput();
    if (!selectedRangeInput) {
      return;
    }

    const rangeStart = numberToCurrency(this.rangeStartTarget.value);
    const rangeEnd = numberToCurrency(this.rangeEndTarget.value);

    let value = "";
    if (selectedRangeInput.value === FILTER_VALUES.GREATER_THAN) {
      value += `> ${rangeStart}`;
    } else if (selectedRangeInput.value === FILTER_VALUES.LESS_THAN) {
      value += `< ${rangeStart}`;
    } else if (selectedRangeInput.value === FILTER_VALUES.EQUAL_TO) {
      value += `= ${rangeStart}`;
    } else {
      value += `entre ${rangeStart} et ${rangeEnd}`;
    }

    return value;
  }

  _selectedRangeInput() {
    return this.rangeChoiceInputTargets.find((input) => input.checked);
  }

  _shouldShowRangeEndInput(rangeInput) {
    return rangeInput.value === FILTER_VALUES.BETWEEN;
  }
}
